<template>
  <div class="filter-item">
    <div class="filter-header">
      <div class="filter-title">
        <slot v-if="$slots.title" name="title"></slot>
        <span v-else>{{ title }}</span>
      </div>
      <div v-if="$slots.default && hideButton!=true">
        <v-btn @click="display = false" size="small" style="font-size:18px" icon="mdi-chevron-up" text elevation="0"
          v-if="display" />
        <v-btn @click="display = true" size="small" style="font-size:18px" icon="mdi-chevron-down" text elevation="0"
          v-else />
      </div>
    </div>
    <div v-if="display">
      <slot/>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

defineProps<{
  title?: string
  hideButton?: boolean
}>()

const display = ref(true)
</script>
<style scoped lang="scss">
.filter-item {
  margin: 10px 0;
  
  .filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
    
    .filter-title {
      font-weight: 600;
      font-size: 13px;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      font-family: 'Outfit', sans-serif;
      color: #475569;
      width: 100%;
    }

    :deep(.v-btn) {
      color: #64748b !important;
      transition: all 0.2s ease;
      
      &:hover {
        color: #1e293b !important;
        background-color: #f1f5f9 !important;
      }
    }
  }
}
</style>
